import {
  BrowserAuthError,
  InteractionRequiredAuthError,
  type AccountInfo,
  type AuthenticationResult,
  type IPublicClientApplication,
} from "@azure/msal-browser";
import { graphLoginRequest } from "./msalConfig";

// Fehler der stillen Erneuerung (unsichtbares iframe), bei denen eine kurze sichtbare
// Anmeldung weiterhilft – z. B. nach Ablauf der 24-h-Anmeldung oder blockierten Cookies.
const SILENT_FAILURES = new Set([
  "monitor_window_timeout",
  "timed_out",
  "block_iframe_reload",
  "silent_logout_unsupported",
  "no_network_connectivity",
]);

// Token holen: erst still, sonst Anmeldefenster, und falls der Browser Popups blockiert,
// per Weiterleitung (die App lädt danach neu und die Person ist wieder angemeldet).
export async function acquireToken(
  instance: IPublicClientApplication,
  account: AccountInfo,
  forceRefresh = false,
): Promise<AuthenticationResult> {
  try {
    return await instance.acquireTokenSilent({ ...graphLoginRequest, account, forceRefresh });
  } catch (err) {
    const interactive =
      err instanceof InteractionRequiredAuthError ||
      (err instanceof BrowserAuthError && SILENT_FAILURES.has(err.errorCode));
    if (!interactive) throw err;
    try {
      return await instance.acquireTokenPopup({ ...graphLoginRequest, account });
    } catch (popupErr) {
      if (popupErr instanceof BrowserAuthError && /popup/i.test(popupErr.errorCode)) {
        await instance.acquireTokenRedirect({ ...graphLoginRequest, account });
      }
      throw popupErr;
    }
  }
}
